import { request } from '@/api/httpClient'

export async function setupUpdateProducts(products) {
  return request({
    method: 'setup/UpdateProducts',
    payload: {
      Products: products
    }
  })
}

export async function setupOrderBusinessProducts(products) {
  return request({
    method: 'setup/OrderBusinessProducts',
    payload: {
      Products: products
    }
  })
}

export async function setupGetDatasets() {
  return request({
    method: 'setup/GetDatasets'
  })
}
